var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2177_652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2177_652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 13V11H21.9999V13H17.9999ZM19.1999 20L15.9999 17.6L17.1999 16L20.3999 18.4L19.1999 20ZM17.1999 8.00003L15.9999 6.40003L19.1999 4.00003L20.3999 5.60003L17.1999 8.00003ZM4.99988 19V15H3.99988C3.44988 15 2.97904 14.8042 2.58738 14.4125C2.19571 14.0209 1.99988 13.55 1.99988 13V11C1.99988 10.45 2.19571 9.9792 2.58738 9.58753C2.97904 9.19586 3.44988 9.00003 3.99988 9.00003H7.99988L12.9999 6.00003V18L7.99988 15H6.99988V19H4.99988ZM13.9999 15.35V8.65003C14.4499 9.05003 14.8124 9.53753 15.0874 10.1125C15.3624 10.6875 15.4999 11.3167 15.4999 12C15.4999 12.6834 15.3624 13.3125 15.0874 13.8875C14.8124 14.4625 14.4499 14.95 13.9999 15.35Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignsWhite);
export default __webpack_public_path__ + "static/media/CampaignsWhite.dddf3dc1cf8ac7e0a84892e836ffedf1.svg";
export { ForwardRef as ReactComponent };